import React, {useEffect} from 'react';
import ReportCard from "../../../../../components/reports/report-card.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";

const CardsContent = ({ data }) => {
    const cards = Object.fromEntries((data?.cards ?? []).map(({ label, value }) => [label, value]));

    return (
        <>
            <div className="flex flex-col">
                <div className="grid grid-cols-3">
                    <ReportCard
                        title="Total de solicitações"
                        value={cards?.total_solicitations ?? 0}
                    />

                    <ReportCard
                        title="Solicitações pendentes"
                        value={cards?.solicitations_pendings ?? 0}
                    />

                    <ReportCard
                        title="Duração média da solicitação"
                        idTitle={'Tempo médio entre criação e finalização das solicitações'}
                        value={cards?.avg_duration ?? '0s'}
                    />
                </div>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default CardsContent;